import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Block, Link } from '@klp/design';

import { LocalLoader } from '@klp/design/Loader';

import { useSelector } from 'react-redux';

import { ProsjektRoutes } from '../config';
import { ProsjektSummaryStatistics } from './ProsjektSummaryStatistics';
import { useGetProsjektStatisticsQuery } from '../services/rtkApi';
import { contextSelectors } from '@klp/contextSelector';
import { usePortfolio } from '@klp/portfolio/store';
import { useCurrentUser } from '@klp/auth';

const useStyles = makeStyles(() => ({
    title: {
        textTransform: 'uppercase',
    },
}));

export default function ProsjektSummaryView() {
    const classes = useStyles();
    const { currentUser, isEDAdmin } = useCurrentUser();
    const { portfolio } = usePortfolio();
    const { selectedContext } = useSelector(contextSelectors);

    const {
        data: prosjektStatistics,
        isLoading,
        isFetching,
    } = useGetProsjektStatisticsQuery(
        {
            ansvarlig: isEDAdmin ? portfolio?.brukerId : currentUser?.epost,
            byggNummer: selectedContext?.id,
        },
        { skip: !currentUser?.epost },
    );

    return (
        <>
            <Block
                marginTop="compact"
                display="inline"
                klpTypographyVariant="xsmall"
                className={classes.title}
                translation="frontPage.project.subtitle"
            />
            <LocalLoader
                isLoading={isLoading || isFetching}
                data-testid="Loader"
            >
                <ProsjektSummaryStatistics statistics={prosjektStatistics} />
            </LocalLoader>
            <Block paddingTop="compact">
                <Link
                    href={ProsjektRoutes.projectSchema()}
                    translation="frontPage.project.actionButtonText"
                />
            </Block>
        </>
    );
}
